import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { interpolateTemplate } from "lib/i18n/dictionary";
import { useLocalizedNavigate } from "lib/i18n/navigation";

import { formatPlural } from "./plural";
import { ReadyDesignThumb } from "./ready-design-thumb";
import type { ReadyDesign } from "./site.documents";
import { READY_DESIGNS_ROUTE } from "./site.routes";
import { useSiteTranslations } from "./use-site-translations";

// "Готові дизайни" in the site's "Дизайн" section: the design the site on the web started from, or,
// before one is published, the design in the draft.
export function ReadyDesignsRow({
  current,
  shown,
  total,
}: {
  current: ReadyDesign | null;
  shown: ReadyDesign | null;
  total: number;
}) {
  const { t, locale } = useSiteTranslations();
  const navigate = useLocalizedNavigate();
  const subtitle = current
    ? interpolateTemplate(t.designs.rowCurrent, { name: current.name, count: String(total) })
    : total > 0
    ? formatPlural(locale, t.designs.rowCount, total)
    : null;

  return (
    <Card>
      <SoftBox p={3}>
        <SoftTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
          {t.designs.section}
        </SoftTypography>
        <SoftBox
          mt={1.5}
          display="flex"
          alignItems="center"
          gap={2}
          role="button"
          tabIndex={0}
          data-testid="provider-site-ready-designs-row"
          onClick={() => navigate(READY_DESIGNS_ROUTE)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") navigate(READY_DESIGNS_ROUTE);
          }}
          sx={{ cursor: "pointer", "&:hover": { opacity: 0.8 } }}
        >
          <SoftBox width="3rem" flexShrink={0}>
            <ReadyDesignThumb uri={(current ?? shown)?.thumbUrl} crop />
          </SoftBox>
          <SoftBox flexGrow={1}>
            <SoftTypography variant="h6">{t.designs.title}</SoftTypography>
            {subtitle ? (
              <SoftTypography variant="button" color="text" fontWeight="regular">
                {subtitle}
              </SoftTypography>
            ) : null}
          </SoftBox>
          <Icon color="disabled">chevron_right</Icon>
        </SoftBox>
      </SoftBox>
    </Card>
  );
}
